const cipaCards = [
  {
    id: 1,
    foto: '../assets/img/cipa/izis-souza.jpg',
    nome: 'IZIS SOUZA DE MOURA ALVES',
    lotacao: 'MMF Maravista',
    funcao: 'Assistente Administrativo',
    genero: 'Feminino'
  },
  {
    id: 2,
    foto: '../assets/img/cipa/guilherme-martins.jpg',
    nome: 'GUILHERME MARTINS GUIMARÃES',
    lotacao: 'MMF Maravista',
    funcao: 'Assistente Administrativo',
    genero: 'Masculino'
  },
  {
    id: 3,
    foto: '../assets/img/cipa/patricia-lopes.jpg',
    nome: 'PATRICIA LOPES DE MELO',
    lotacao: 'MMF Maravista',
    funcao: 'Agente Comunitário de Saúde',
    genero: 'Feminino'
  },
  {
    id: 4,
    foto: '../assets/img/cipa/sandra-lucia.jpg',
    nome: 'SANDRA LUCIA FONSECA ALVES',
    lotacao: 'MMF Ilha da Conceição',
    funcao: 'Auxiliar de Saúde Bucal',
    genero: 'Feminino'
  },
  {
    id: 5,
    foto: '../assets/img/cipa/alessandro-alayn.jpg',
    nome: 'ALESSANDRO ALAYN GARCIA DE SOUZA',
    lotacao: 'MMF Várzea das Moças',
    funcao: 'Agente Comunitário de Saúde',
    genero: 'Masculino'
  },
  {
    id: 6,
    foto: '../assets/img/cipa/victor-machado.jpg',
    nome: 'VICTOR MACHADO DE MELLO ANDRADE',
    lotacao: 'UAI',
    funcao: 'Educador Físico',
    genero: 'Masculino'
  },
  {
    id: 7,
    foto: '../assets/img/cipa/edinita-cunha.jpg',
    nome: 'EDINITA CUNHA DE OLIVEIRA SOUZA',
    lotacao: 'MMF Cafubá III',
    funcao: 'Técnica de Enfermagem',
    genero: 'Feminino'
  },
  {
    id: 8,
    foto: '../assets/img/cipa/wesley-henrique.jpg',
    nome: 'WESLEY HENRIQUE SANTOS DE ASSIS',
    lotacao: 'MMF Nova Brasília',
    funcao: 'Técnico de Enfermagem',
    genero: 'Masculino'
  },
  {
    id: 9,
    foto: '../assets/img/cipa/alessandra_conci.jpg',
    nome: 'ALESSANDRA CONCI FICAGNA',
    lotacao: 'Sede - DETEC',
    funcao: 'Analista Administrativo',
    genero: 'Feminino'
  },
  {
    id: 10,
    foto: '../assets/img/cipa/ingrid-meneses-sampaio.jpg',
    nome: 'INGRID MENESES SAMPAIO',
    lotacao: 'CAPS Casa do Largo',
    funcao: 'Enfermeira',
    genero: 'Feminino'
  },
  {
    id: 11,
    foto: '../assets/img/cipa/janaina-dos-santos.jpg',
    nome: 'JANAINA DOS SANTOS ALVES',
    lotacao: 'CAPS Casa do Largo',
    funcao: 'Educadora Física',
    genero: 'Feminino'
  },
  {
    id: 12,
    foto: '../assets/img/cipa/barbara-talita-bernardo-negreiro.jpg',
    nome: 'BARBARA TALITA BERNARDO NEGREIRO',
    lotacao: 'MMF Coronel Leôncio',
    funcao: 'Técnica de Enfermagem',
    genero: 'Feminino'
  },
  {
    id: 13,
    foto: '../assets/img/cipa/patricia-martins-augusto-dias.jpg',
    nome: 'PATRICIA MARTINS AUGUSTO DIAS',
    lotacao: 'MMF Cafubá I',
    funcao: 'Assistente Administrativo',
    genero: 'Feminino'
  },
  {
    id: 14,
    foto: '../assets/img/cipa/ardalla-de-almeida.jpg',
    nome: 'ARDALLA DE ALMEIDA GUIMARÃES',
    lotacao: 'MMF Cafubá I',
    funcao: 'Agente Comunitário de Saúde',
    genero: 'Feminino'
  },
  {
    id: 15,
    foto: '../assets/img/cipa/aline-almeida-de-aguiar.jpg',
    nome: 'ALINE ALMEIDA DE AGUIAR',
    lotacao: 'MMF Alarico',
    funcao: 'Cirurgiã-dentista',
    genero: 'Feminino'
  },
  {
    id: 16,
    foto: '../assets/img/cipa/noemi-de-sousa.jpg',
    nome: 'NOEMI DE SOUSA PAMPOLHA NEVES',
    lotacao: 'MMF Souza Soares',
    funcao: 'Agente Comunitário de Saúde',
    genero: 'Feminino'
  },
  {
    id: 17,
    foto: '../assets/img/cipa/maria-aparecida-faustino.jpg',
    nome: 'MARIA APARECIDA FAUSTINO ERNANDI',
    lotacao: 'CAPS Casa do Largo',
    funcao: 'Técnica de Enfermagem',
    genero: 'Feminino'
  },
];

export default cipaCards;
